import { useNavigate } from "react-router";
import {
  Dialog,
  Heading,
  Content,
  Text,
  ButtonGroup,
  Button,
  LinkButton,
} from "@react-spectrum/s2";
import DownloadIcon from "@react-spectrum/s2/icons/Download";

import { useVideo, useUpdateVideo } from "@app/hooks/videos";
import { usePresignURL } from "@app/hooks/s3";

export const EditVideoDialog = ({ videoId }) => {
  const navigate = useNavigate();

  const video = useVideo(videoId);
  const updateVideo = useUpdateVideo(videoId);

  const videoUrlQuery = usePresignURL(video.data?.videoPath);

  const handleEdit = () => {
    updateVideo.mutate(
      { videoPath: null, jobId: null },
      {
        onSuccess: () => {
          navigate(`/projects/new/${videoId}`);
        },
      },
    );
  };

  return (
    <Dialog>
      {({ close }) => (
        <>
          <Heading slot="title">Edit {video.data?.name ?? ""} project</Heading>
          <Content>
            <p>Editing project will overwrite existing data.</p>
            <p>Would you like to download a backup before proceeding?</p>
            <LinkButton
              href={videoUrlQuery.data?.presignURL}
              download
              isDisabled={videoUrlQuery.isLoading}
              fillStyle="outline"
              variant="secondary"
              size="M"
            >
              <DownloadIcon />
              <Text>Download video</Text>
            </LinkButton>
          </Content>
          <ButtonGroup>
            <Button onPress={close} variant="secondary">
              Cancel
            </Button>
            <Button
              onPress={handleEdit}
              variant="primary"
              isPending={updateVideo.isPending}
            >
              Edit
            </Button>
          </ButtonGroup>
        </>
      )}
    </Dialog>
  );
};
